export default __webpack_public_path__ + "fonts/bg-decoration.svg";